import React, { useState } from "react";
import { createPortal } from "react-dom";
import { createCustomerSession } from "../services/customerSessionService";

function CustomerSelectModal({ customers, onClose }) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const handleSelect = async (customer) => {
    try {
      setLoading(true);
      setError("");

      const data = await createCustomerSession(customer.customer_id);

      localStorage.setItem("token", data.access_token);
      localStorage.setItem("customer_id", data.customer_id);
      localStorage.setItem("roles", JSON.stringify(data.roles));
      localStorage.setItem("view_as", customer.customer_name);

      onClose();
      window.location.reload();

    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  // ✅ PORTAL RENDER
  return createPortal(
    <div
      className="modal fade show"
      style={{
        display: "block",
        backgroundColor: "rgba(0,0,0,0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        width: "100%",
        height: "100%",
        zIndex: 9999, 
      }}
    >
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">

          <div className="modal-header">
            <h5 className="modal-title">Select Customer</h5>
            <button className="btn-close" onClick={onClose}></button>
          </div>

          <div className="modal-body">

            {error && <p className="text-danger">{error}</p>}

            <ul className="list-group">
              {customers?.map((c) => (
                <li
                  key={c.customer_id}
                  className="list-group-item list-group-item-action"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleSelect(c)}
                >
                  {c.customer_name}
                </li>
              ))}
            </ul>

          </div>

          {loading && (
            <div className="text-center p-2">Switching...</div>
          )}

        </div>
      </div>
    </div>,
    document.body // 🔥 THIS FIXES YOUR ISSUE
  );
}

export default CustomerSelectModal;